import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Alert,
  CircularProgress,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormControl,
  FormLabel,
  Divider
} from '@mui/material';
import { api } from '../../services/api';
import { showErrorToastify, showSuccessToastify } from '../../utils';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DownloadIcon from '@mui/icons-material/Download';

export const ImportarRespuestasModal = ({ open, onClose, eventoId }) => {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [tarifas, setTarifas] = useState([]);
  const [selectedTarifa, setSelectedTarifa] = useState('');
  const [loadingPlantilla, setLoadingPlantilla] = useState(false);

  useEffect(() => {
    const fetchTarifas = async () => {
      try {
        const response = await api.tarifas.getAll(eventoId);
        setTarifas(response.data?.tarifas ?? []);
      } catch (error) {
        console.error('Error al obtener tarifas:', error);
        setError('Error al cargar tarifas');
      }
    };
    fetchTarifas();
  }, [eventoId]);

  const handleTarifaChange = (event) => {
    setSelectedTarifa(event.target.value);
    setError('');
  };

  const handleDownloadPlantilla = async () => {
    if (!selectedTarifa) {
      setError('Debe seleccionar una tarifa');
      return;
    }

    const tarifaSeleccionada = tarifas.find(t => t.id.toString() === selectedTarifa);
    if (!tarifaSeleccionada) {
      setError('Error al obtener información de la tarifa');
      return;
    }

    console.log("trarifaseleccionada", tarifaSeleccionada);

    setLoadingPlantilla(true);
    try {
      const response = await api.tickets.descargarPlantillaRespuestas(eventoId, selectedTarifa);
      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Plantilla_Respuestas_${tarifaSeleccionada.concepto}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      showErrorToastify('Error al descargar plantilla');
    } finally {
      setLoadingPlantilla(false);
    }
  };
 /*  console.log("selectedtarifa", selectedTarifa); */
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file && !file.name.match(/\.(xlsx|xls)$/)) {
      setError('Solo se permiten archivos Excel (.xlsx, .xls)');
      setFile(null);
      return;
    }
    setFile(file);
    setError('');
  };

  const handleSubmit = async () => {
    if (!selectedTarifa) {
      setError('Debe seleccionar una tarifa');
      return;
    }
    if (!file) {
      setError('Debe seleccionar un archivo');
      return;
    }

    setLoading(true);
    const formData = new FormData();
    formData.append('file', file);
    formData.append('tarifaId', selectedTarifa);

    try {
      await api.tickets.importarRespuestas(eventoId, formData);
      showSuccessToastify('Respuestas importadas correctamente');
      onClose();
    } catch (error) {
      showErrorToastify(error.response?.data?.message || 'Error al importar respuestas');
      setError(error.response?.data?.message || 'Error al importar respuestas');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Importar Respuestas Adicionales</DialogTitle>
      <DialogContent>
        <DialogContentText className="mb-3">
          Primero seleccione la tarifa para la cual desea importar respuestas.
          Luego podrá descargar la plantilla y completarla con las respuestas.
        </DialogContentText>

        <FormControl component="fieldset" className="mb-1">
          <FormLabel component="legend">Seleccione una tarifa</FormLabel>
          <RadioGroup value={selectedTarifa} onChange={handleTarifaChange}>
            {tarifas.map((tarifa) => (
              <FormControlLabel
                sx={{ marginBottom: 0 }}
                key={tarifa.id}
                value={tarifa.id.toString()}
                control={<Radio />}
                label={tarifa.concepto}
              />
            ))}
          </RadioGroup>
        </FormControl>

        <Divider className="mt-1 mb-2" />

        <div className="d-flex flex-row justify-content-center gap-2">
          <Button
          sx={{color:"#5656FF", borderColor:"#5656FF",  fontSize:"14px !important"}}
            variant="text"
            onClick={handleDownloadPlantilla}
            startIcon={loadingPlantilla ? <CircularProgress size={20} /> : <DownloadIcon />}
            disabled={!selectedTarifa || loadingPlantilla}
          >
            {loadingPlantilla ? 'Descargando...' : 'Descargar plantilla'}
          </Button>

          <Button
          sx={{color:"#5656FF", borderColor:"#5656FF", fontSize:"14px !important"}}
            variant="outlined"
            component="label"
            startIcon={<CloudUploadIcon />}
            disabled={!selectedTarifa}
          >
            {file ? file.name : 'Cargar archivo excel'}
            <input
              type="file"
              hidden
              accept=".xlsx,.xls"
              onChange={handleFileChange}
            />
          </Button>

          {error && <Alert severity="error">{error}</Alert>}
        </div>
      </DialogContent>
      <DialogActions sx={{padding:"10px"}}>
        <Button sx={{color:"#5656FF"}} onClick={onClose} disabled={loading}>
          Cancelar
        </Button>
        <Button
        sx={{backgroundColor:"#5656FF", color:"#fff"}}
          onClick={handleSubmit}
          variant="contained"
          disabled={loading || !file || !selectedTarifa}
          startIcon={loading && <CircularProgress size={20} />}
        >
          {loading ? 'Importando...' : 'Importar'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};